var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 16,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5,2.9019a4.7308,4.7308,0,1,0,4.7308,4.7308A4.7309,4.7309,0,0,0,5.5,2.9019Zm2.88,7.2608A3.8983,3.8983,0,0,0,5.5,9.165a3.8983,3.8983,0,0,0-2.88.9977,3.8435,3.8435,0,1,1,6.7306-2.53A3.8184,3.8184,0,0,1,8.38,10.1627ZM7.1051,6.71A1.649,1.649,0,0,1,5.5,8.4,1.649,1.649,0,0,1,3.8949,6.71,1.6489,1.6489,0,0,1,5.5,5.0206,1.6489,1.6489,0,0,1,7.1051,6.71Z",
    fill: "6E6E73"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.36f05260f8f8195eaecb0adcd044ea89.svg";
export { ForwardRef as ReactComponent };